<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">{{ YearIssue_No }}</div>
                  <div class="title_more2">
                    <a href="/">首页</a>>{{ titles }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="dqml">
                    <IssueArticleListControl
                      :newListTitle="newListTitle"
                      :List="newList"
                      :isOA="false"
                      :ischeckbox="true"
                      iscount="true"
                      :count="count"
                      :type="0"
                      :isycb="false"
                      :isdatab="true"
                      :isdataa="false"
                    ></IssueArticleListControl>
                    <commonpage
                      :count="count"
                      @pageSize="pageSize"
                      @pageindex="index"
                      :index="paramas"
                    ></commonpage>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import commonpage from '../components/CommonPage'
import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      data: {},
      newList: [],
      List: [],
      Lista: [],
      newListTitle: '',
      cotype: '',
      FileGUID: '',
      count: 0,
      titles: '',
      isyuchuban: false,
      YearIssue_No: '',
      id: 0,
      type: '',
      paramas: {
        PageSize: 10,
        PageIndex: 0,
        IssueId: 0,
      },
    }
  },
  components: {
    IssueArticleListControl,
    commonpage,
  },
  created() {
    this.id = this.$route.query.IssueId
    this.type = this.$route.query.type
    this._getListb(this.paramas.PageSize, this.paramas.PageIndex)
  },
  watch: {
    $route(to, from) {
      if (to.query.IssueId !== from.query.IssueId) {
        this.type = to.query.type
        this.id = to.query.IssueId
        this._getListb(this.paramas.PageSize, this.paramas.PageIndex)
      }
    },
  },
  methods: {
    _getListb(pageSize, PageIndex) {
      var time = new Date().getTime()
      this.paramsa = {
        PageSize: pageSize,
        PageIndex: PageIndex,
        Type: this.type,
        Key: this.id,
        src: time,
      }
      this.$store
        .dispatch('_getListb', this.paramsa)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.newList = res.data.Data
            this.count = res.data.ItemCount
            this.YearIssue_No = res.data.Title
            this.titles = res.data.Title
            document.title = res.data.Title
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
    pageSize(val) {
      this.paramas.PageSize = val
      this._getListb(this.paramas.PageSize, this.paramas.PageIndex)
    },
    index(val) {
      this.paramas.PageIndex = val
      this._getListb(this.paramas.PageSize, this.paramas.PageIndex)
    },
  },
}
</script>

<style scoped></style>
